import React, { Component, useContext, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LabPrice from "../../assets/data/Lab_and_radiology_Prices_for_website.json";
import { error } from "jquery";
import Pagination from "react-js-pagination";
import { MyContext } from "../MyProvider";
import { USER_LOCAL_ID } from "../../constants";
import { scAxios, scAxiosAdmin, thirdparty } from "../..";

const Investigation = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page
  const { addToCart, isInCart } = useContext(MyContext);
  const [filteredData, setfilteredData] = useState("");
  const [LabPrice, setLabPrice] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      try {
        const response = scAxiosAdmin
          .get("/investigations")
          .then((result) => {
            setLabPrice(result.data);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // Initial data fetch
  }, []);
  // Filter data based on search term

  useEffect(() => {
    const filteredData =
      LabPrice &&
      LabPrice.filter((item) =>
        item["Product_Name"].toLowerCase().includes(searchTerm.toLowerCase())
      );

    setfilteredData(filteredData);
  }, [LabPrice, searchTerm]);
  // Get current items to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  // Handle search term change
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <div>
      <SEO
        title="Investigation | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="newsevents, Singlenewsevents"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="pt-5">
        <form
          className="container d-flex w-75 mx-auto mb-3 align-items-center form-control"
          role="search"
        >
          <input
            className="form-control me-2 "
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
            style={{ background: "transparent", border: "none" }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
          </svg>
        </form>
        <div className="table-responsive">
          <table className="container table table-striped table-hover mx-auto">
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Product Name</th>
                <th>Product Group</th>
                <th>OPD Price</th>
                <th className="ps-5">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems
                ? currentItems.map((item) => (
                    <tr key={item["id"]}>
                      <td>{item["id"]}</td>
                      <td>{item["Product_Name"]}</td>
                      <td>{item["Product_Group"]}</td>
                      <td>{item["opd_amount"]}</td>
                      <td className="">
                        {isInCart(item.id) ? (
                          <button
                            style={{ backgroundColor: "#187979" }}
                            className="btn btn-sm rounded rounded-lg invBtn"
                            onClick={() => addToCart(item, "investigation")}
                          >
                            <div
                              className="d-inline-block"
                              style={{ position: "relative" }}
                            >
                              <i className="fa-solid fa-trash-can me-2"></i>
                            </div>
                            <span className="d-none d-lg-inline-block">
                              Remove From Cart{" "}
                            </span>
                          </button>
                        ) : (
                          <button
                            style={{ backgroundColor: "#187979" }}
                            className="btn btn-sm rounded rounded-lg invBtn"
                            onClick={() => addToCart(item, "investigation")}
                          >
                            <div
                              className="d-inline-block"
                              style={{ position: "relative" }}
                            >
                              <i className="fa-solid fa-bag-shopping me-2"></i>
                            </div>
                            <span className="d-none d-lg-inline-block">
                              Add to Cart
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                : ""}
            </tbody>
          </table>
        </div>

        <Pagination
          activePage={currentPage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={filteredData ? filteredData.length : 1}
          pageRangeDisplayed={5}
          onChange={handlePageChange}
        />
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Investigation;



// WEBPACK FOOTER //
// ./src/component/frontend/Investigation.js